import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useWA, useLoad, useDebounced, PageHead, Card, Tabs, Search, Btn, Badge, Pager, Skeleton, Empty, ErrorBox, Avatar, num, fdt, ago } from "../ui";
import { siteLink } from "../api";

/* Reviews of YCNP written by real members — approve to show them on the home page */
const TAKE = 30;
const TABS = [["PENDING", "Pending"], ["APPROVED", "Homepage पर"], ["HIDDEN", "छिपे हुए"], ["ALL", "सभी"]];
const TONE = { PENDING: "amber", APPROVED: "green", HIDDEN: "gray" };

const Stars = ({ n }) => <span className="text-amber-500 tracking-tight" aria-label={`${n} stars`}>{"★".repeat(n)}<span className="opacity-25">{"★".repeat(5 - n)}</span></span>;

export default function Reviews() {
  const { run, confirm } = useWA();
  const [status, setStatus] = useState("PENDING");
  const [q, setQ] = useState("");
  const [skip, setSkip] = useState(0);
  const dq = useDebounced(q);
  useEffect(() => setSkip(0), [status, dq]);
  const { data, loading, error, reload } = useLoad("reviews", { status, q: dq, take: TAKE, skip }, [status, dq, skip]);
  const items = (data && data.items) || [];

  const act = async (id, op, msg, ask) => {
    if (ask && !(await confirm(ask))) return;
    try {
      await run("reviewSet", { id, op }, msg);
      reload();
    } catch (e) {
      /* toast */
    }
  };

  return (
    <div>
      <PageHead icon="fa-solid fa-star" title="Reviews" subtitle="Members के लिखे YCNP reviews — Approve करने पर homepage पर दिखते हैं"
        actions={<a href={siteLink("/#reviews")} target="_blank" rel="noreferrer"><Btn icon="fa-solid fa-arrow-up-right-from-square">Homepage देखें</Btn></a>} />
      {data && (
        <Card className="mb-4">
          <p className="text-sm">Homepage पर <b>{num(data.approved)}</b> reviews · औसत <b>{Number(data.avg || 0).toFixed(1)} ★</b></p>
          <p className="text-[12px] wa-muted mt-1">सिर्फ़ असली, logged-in members review लिख सकते हैं। अपनी पसंद से बुरे reviews छिपाने के बजाय, सिर्फ़ गाली-गलौज, spam या झूठे reviews छिपाएँ — ईमानदार reviews से ही भरोसा बनता है।</p>
        </Card>
      )}
      <div className="flex flex-col gap-3 mb-4">
        <Tabs tabs={TABS} value={status} onChange={setStatus} />
        <Search value={q} onChange={setQ} placeholder="नाम, email या शब्द…" />
      </div>
      <ErrorBox msg={error} retry={reload} />
      {loading && !data ? <Skeleton rows={4} h={110} /> : !items.length ? (
        <Card><Empty icon={status === "PENDING" ? "fa-solid fa-check-double" : "fa-regular fa-star"} title={status === "PENDING" ? "कोई नया review नहीं 🎉" : "कुछ नहीं मिला"} /></Card>
      ) : (
        <div className="space-y-3">
          {items.map((r) => (
            <div key={r.id} className="wa-card wa-in p-4 flex flex-wrap gap-4 items-start">
              <div className="flex-1 min-w-[260px]">
                <div className="flex flex-wrap items-center gap-2">
                  <Avatar name={r.user?.name || r.user?.email} image={r.user?.image} size={28} />
                  <Link to={`/website/users?open=${r.user?.id}`} className="font-bold hover:underline">{r.user?.name || "—"}</Link>
                  <span className="text-[12.5px] wa-muted">{r.user?.email}</span>
                  <Badge tone={TONE[r.status] || "gray"}>{r.status}</Badge>
                </div>
                <p className="mt-2"><Stars n={r.rating} /></p>
                <p className="text-[14px] mt-1.5 whitespace-pre-line break-words">{r.text}</p>
                <p className="text-[12px] wa-muted mt-1.5">{fdt(r.updatedAt)} ({ago(r.updatedAt)})</p>
              </div>
              <div className="flex flex-wrap gap-2 sm:flex-col sm:items-stretch">
                {r.status !== "APPROVED" && <Btn variant="success" icon="fa-solid fa-check" onClick={() => act(r.id, "APPROVED", "Homepage पर दिखने लगा")}>Approve</Btn>}
                {r.status !== "HIDDEN" && <Btn icon="fa-regular fa-eye-slash" onClick={() => act(r.id, "HIDDEN", "Review छिप गया")}>छिपाएँ</Btn>}
                <Btn size="sm" className="!text-rose-600" icon="fa-regular fa-trash-can" aria-label="Delete" onClick={() => act(r.id, "delete", "Review delete हो गया", { title: "यह review delete करें?", text: "सिर्फ़ spam/गलत entry के लिए।", danger: true })} />
              </div>
            </div>
          ))}
          <Pager total={data.total} take={TAKE} skip={skip} onChange={setSkip} />
        </div>
      )}
    </div>
  );
}
